import * as React from 'react';
import { CalendarField } from '@ghq-abi/design-system';
import deLocale from 'date-fns/locale/de';
import enUSLocale from 'date-fns/locale/en-US';
import esLocale from 'date-fns/locale/es';
import frLocale from 'date-fns/locale/fr';
import frCALocale from 'date-fns/locale/fr-CA';
import itLocale from 'date-fns/locale/it';
import jaLocale from 'date-fns/locale/ja';
import koLocale from 'date-fns/locale/ko';
import nlLocale from 'date-fns/locale/nl';
import ptBRLocale from 'date-fns/locale/pt-BR';
import ruLocale from 'date-fns/locale/ru';
import ukLocale from 'date-fns/locale/uk';
import viLocale from 'date-fns/locale/vi';
import zhCNLocale from 'date-fns/locale/zh-CN';

import { useTolgeeLocale } from '~/hooks/stellarWidget/useTolgeeLocale';
import type { Language } from '~/shared/constants/i18n';

type CalendarProps = React.ComponentProps<typeof CalendarField>;

const LOCALE_MAP: Record<Language, unknown> = {
  'de-DE': deLocale,
  'en-US': enUSLocale,
  es: esLocale,
  'fr-CA': frCALocale,
  'fr-FR': frLocale,
  'it-IT': itLocale,
  'ja-JP': jaLocale,
  'ko-KR': koLocale,
  'nl-NL': nlLocale,
  'pt-BR': ptBRLocale,
  'ru-RU': ruLocale,
  'uk-UA': ukLocale,
  'vi-VN': viLocale,
  'zh-CN': zhCNLocale,
};

export function Calendar(props: CalendarProps) {
  const locale = useTolgeeLocale();
  const dateFnsLocale = React.useMemo(
    () => LOCALE_MAP[locale as Language] ?? enUSLocale,
    [locale]
  );

  return <CalendarField {...props} locale={dateFnsLocale} />;
}
